import type { GalleryImage } from '../types/media'

export const GALLERY_IMAGES: GalleryImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/g7yq2x1c7MZkrRRjJz39eQ/photo_2026-09-21_13.17.00.jpg',
    alt: 'An ensemble of masked and unmasked dancers runs through pools of white stage light',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/og7UHFRfmw3L2kY4Eis8r9/photo_2026-09-21_13.16.51.jpg',
    alt: 'A sculptural blue fabric form moves beside a seated figure and a glowing amber grid',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1kS41LnwRJKdFssx8jKBA9/photo_2026-09-21_13.16.36.jpg',
    alt: 'Dancers gather around sculptural chairs under saturated orange stage light',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2wyJMhMhqu1mz382fCYXmZ/photo_2026-09-21_13.17.04.jpg',
    alt: 'An ensemble in sheer black costumes performs on a checkered floor beneath white beams',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5DgyWD971LowWTNwPjBJS6/doubles.jpg',
    alt: 'Two dancers mirror each other in cool blue stage light',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/11CtvuRPDu86E3y84v1aBW/final_solo.jpg',
    alt: 'A solo dancer captured in a moment of stillness under ice-blue light',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qgfHRhgLfi15nwEQRgGCcX/flashes.jpg',
    alt: 'Dancers frozen mid-motion under flashes of cold white light',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cEqZ21JZsMjUyGwWN6XiZk/mary.jpg',
    alt: 'A dancer illuminated in a beam of cold light against darkness',
  },
]
